
import { Vue, Component } from 'nuxt-property-decorator'
import { apiWebNurseryGuestMePath, destroyApiWebUserSessionPath } from '~/rails/routes'
import NavbarForGuest from '~/components/NavbarForGuest.vue'
import ApplicationErrorAlert from '~/components/ApplicationErrorAlert.vue'
import DevMark from '~/components/DevMark.vue'

@Component({
  components: {
    DevMark,
    NavbarForGuest,
    ApplicationErrorAlert
  }
})
export default class GuestLayout extends Vue {
  async mounted (): Promise<void> {
    try {
      const me = await this.$axios.$get<{
        demo: boolean;
      }>(apiWebNurseryGuestMePath())
      this.$store.commit('me/setDemo', me.demo)
      // 10分周期でセッションの有効状態をチェックする
      // 無効(401)な場合、axiosで処理され総合管理ログインページへリダイレクトされる
      setInterval(() => {
        this.$axios.$get(apiWebNurseryGuestMePath())
      }, 600000)
    } catch (e) {
      if (e.response?.status === 401) { return }

      console.error(e)
      this.rollbarError(e)
    }
  }

  async logout (): Promise<void> {
    // TODO: 検証用のため確認ダイアログのデザイン未実装
    const res = await this.$axios.delete(destroyApiWebUserSessionPath())
    if (res.status === 200) {
      this.$router.push('/guest_login')
    } else {
      this.$message({
        message: 'ログアウトに失敗しました',
        type: 'error'
      })
    }
  }
}
